import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Business Type Classification',
  basePath: '/business-type-classification',
  columns: [
    { key: 'title', label: 'Title', sortable: true },
  ],
  fields: [
    { key: 'title', label: 'Title', type: 'text', required: true },
  ],
  defaultSort: { field: 'title', dir: 'asc' },
});
